<template>
	<div class="add_or_edit_topic">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">{{ pageTitle }}</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-form :model="addTopicForm" :rules="addTopicFormRules" ref="addTopicFormRef" label-width="100px" class="demo-addTopicForm">
											<el-form-item label="课题级别" prop="projectLevelId">
												<el-select v-model="addTopicForm.projectLevelId" placeholder="请选择" @change="topicLevelChange">
													<el-option v-for="item in topicLevelOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="课题类别" prop="projectTypeId">
												<el-select :disabled="topicTypeOptions.length == 0" v-model="addTopicForm.projectTypeId" placeholder="请先选择课题级别">
													<el-option v-for="item in topicTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="立项编号" prop="projectNumberPrefix">
												<el-input v-model="addTopicForm.projectNumberPrefix"></el-input>
											</el-form-item>
											<el-form-item label="课题名称" prop="declareName"><el-input v-model="addTopicForm.declareName"></el-input></el-form-item>
											<el-form-item label="课题负责人" prop="oneEmceeName">
												<el-input v-model="addTopicForm.oneEmceeName" @clear="clearUser('one')" @focus="selectUser('one')" clearable></el-input>
											</el-form-item>
											<el-form-item label="承担单位" prop="oneUnitName">
												<el-input v-model="addTopicForm.oneUnitName" :disabled="true"></el-input>
											</el-form-item>
											<el-form-item label="预期结果" prop="expectedResearchResults">
												<el-checkbox-group v-model="addTopicForm.expectedResearchResults">
													<el-checkbox :label="item.label" v-for="(item, index) in researchResultsList" :key="index">{{ item.label }}</el-checkbox>
												</el-checkbox-group>
											</el-form-item>
											<el-form-item label="所属学段" prop="learningType">
												<el-radio-group v-model="addTopicForm.learningType">
													<el-radio :label="item.id" v-for="(item, index) in learningTypeList" :key="index">{{ item.label }}</el-radio>
												</el-radio-group>
											</el-form-item>

											<el-form-item label="研究领域" prop="researchFieId">
												<el-cascader
													v-model="addTopicForm.researchFieId"
													:options="researchFieOptions"
													:props="{ label: 'name', value: 'id', checkStrictly: true }"
													clearable
												></el-cascader>
											</el-form-item>

											<el-form-item label="所属学科" prop="disciplineId">
												<el-select v-model="addTopicForm.disciplineId" placeholder="请选择">
													<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="立项日期" prop="projectTime">
												<el-date-picker
													v-model="addTopicForm.projectTime"
													type="date"
													value-format="yyyy-MM-dd HH:mm:ss"
													placeholder="选择日期"
												></el-date-picker>
											</el-form-item>
											<el-form-item label="完成日期" prop="expectedClosingTime">
												<el-date-picker
													v-model="addTopicForm.expectedClosingTime"
													type="date"
													value-format="yyyy-MM-dd HH:mm:ss"
													placeholder="选择日期"
												></el-date-picker>
											</el-form-item>
											<el-form-item label="第二负责人" prop="twoEmceeValue">
												<el-input v-model="addTopicForm.twoEmceeValue" @clear="clearUser('two')" @focus="selectUser('two')" clearable></el-input>
											</el-form-item>
											<el-form-item label=" ">
												<el-button type="primary" @click="createTopic">保存</el-button>
												<el-button type="primary" @click="goBack">返回</el-button>
											</el-form-item>
										</el-form>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>

		<!-- 选择负责人对话框 -->
		<el-dialog title="请选择第二负责人" :visible.sync="userListDialogVisible" width="70%" :close-on-click-modal="false">
			<el-form :inline="true" ref="form" :model="userParams" label-width="80px">
				<el-form-item label="真实姓名"><el-input v-model="userParams.realName"></el-input></el-form-item>
				<!-- <el-form-item label="登录名">
				  <el-input v-model="userParams.username"></el-input>
				</el-form-item> -->
				<!-- <el-form-item label="区域">
				  <el-cascader placeholder="请选择区域" v-model="userParams.region" clearable :props="{ value: 'id', label: 'name' }" :options="areaOptions" @change="areaChange"></el-cascader>
				</el-form-item> -->
				<el-form-item label="单位">
					<!-- <el-select v-model="userParams.unitId" :disabled="unitOptions.length===0" clearable filterable placeholder="请先选择区域">
				    <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
				  </el-select> -->
					<el-input v-model="userParams.unitName" placeholder="请输入单位名称"></el-input>
				</el-form-item>
				<el-form-item><el-button type="primary" @click="search">查询</el-button></el-form-item>
			</el-form>
			<el-table border :data="userList" highlight-current-row @current-change="handleCurrentChange" style="width: 100%">
				<el-table-column type="index" width="50" label="#"></el-table-column>
				<el-table-column property="realName" label="姓名"></el-table-column>
				<el-table-column property="sex" label="性别">
					<template v-slot:default="scoped">
						{{ scoped.row.sex == 1 ? '男' : '女' }}
					</template>
				</el-table-column>
				<!-- <el-table-column property="username" label="用户名" width="120"></el-table-column> -->
				<!-- <el-table-column property="name" label="角色">
					<template slot-scope="scope">
						{{ scope.row.roleNames.join('、') }}
					</template>
				</el-table-column> -->
				<el-table-column property="unitName" label="单位"></el-table-column>
				<!-- <el-table-column property="address" label="状态">
					<template slot-scope="scope">
						{{ scope.row.status == 1 ? '可用' : '禁用' }}
					</template>
				</el-table-column> -->
			</el-table>

			<el-pagination
				style="text-align: center;margin-top: 20px;"
				@size-change="handleSizeChange"
				@current-change="currentPageNumberChange"
				:current-page="userParams.pageNumber"
				:page-sizes="[10, 20, 50]"
				:page-size="userParams.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="userTotal"
			></el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button @click="userListDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
import { getUnderStudyTopicList, createOrEditUnderStudyTopic, delUnderStudyTopic } from '@/api/after/topicManage.js';
import { getUserList } from '@/api/after/systemManagement.js';
import { isHasNotFinishTopic } from '@/api/after/projectApplication.js';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			pageTitle: '创建在研课题',
			addTopicForm: {
				projectLevelId: '', //	课题级别id
				projectLevelName: '', //	课题级别名称
				projectTypeId: '', //	课题类别id
				projectTypeName: '', //课题类别名称
				projectNumberPrefix: '', //	立项编号前缀
				projectNumber: '', //	立项编号
				declareName: '', //课题名称
				oneEmceeId: '', //第一负责人id
				oneEmceeName: '', //	第一负责人名称
				// oneEmceeValue:'',//负责人名称和单位
				// oneUnitId:'',//第一负责人单位id
				oneUnitName: '', //第一负责人单位名称
				twoEmceeId: '', //第二负责人id
				twoEmceeName: '', //第二负责人名称
				twoEmceeValue: '', //第二负责人名称+单位
				// twoUnitId:'',//第二负责人单位id
				// twoUnitName:'',//第二负责人单位名称
				expectedResearchResults: [], //预期研究成果类型(0:专著,1:案例,2:论文,3:研究报告,4:教材,5:工具书,6:电脑软件,7:其他)
				learningType: '', //所属学段类型(0:幼儿园，1:小学,2:初中,3:高中,4:高/中职,5:其他)
				learningTypeName: '', //所属学段类型名称
				disciplineId: '', //所属学科id
				disciplineName: '', //所属学科名称
				projectTime: '', //立项批准时间
				expectedClosingTime: '', //完成日期
				researchFieId: [], //研究领域id
				researchFieName: '' //研究领域名称
			},
			addTopicFormRules: {
				projectLevelId: [{ required: true, message: '请选择课题级别', trigger: 'change' }],
				projectTypeId: [{ required: true, message: '请选择课题类别', trigger: 'change' }],
				projectNumberPrefix: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
				declareName: [{ required: true, message: '请输入课题名称', trigger: 'blur' }],
				learningType: [{ required: true, message: '请选择学段', trigger: 'change' }],
				disciplineId: [{ required: true, message: '请选择学科', trigger: 'change' }],
				projectTime: [{ required: true, message: '请输入立项日期', trigger: 'blur' }],
				expectedClosingTime: [{ required: true, message: '请输入完成日期', trigger: 'blur' }],
				oneEmceeName: [{ required: true, message: '请选择负责人', trigger: 'change' }]
			},
			topicLevelOptions: [], //课题级别选项
			topicTypeOptions: [], //课题类别选项
			disciplineOptions: [], //所属学科选项
			// 预期研究成果列表
			researchResultsList: [
				{
					value: 0,
					label: '专著'
				},
				{
					value: 1,
					label: '案例'
				},
				{
					value: 2,
					label: '论文'
				},
				{
					value: 3,
					label: '研究报告'
				},
				{
					value: 4,
					label: '教材'
				},
				{
					value: 5,
					label: '工具书'
				},
				{
					value: 6,
					label: '电脑软件'
				},
				{
					value: 7,
					label: '其他'
				}
			],
			// 学段列表
			learningTypeList: [
				{
					id: 0,
					label: '幼儿园'
				},
				{
					id: 1,
					label: '小学'
				},
				{
					id: 2,
					label: '初中'
				},
				{
					id: 3,
					label: '高中'
				},
				{
					id: 4,
					label: '高/中职'
				},
				{
					id: 5,
					label: '其他'
				}
			],
			userParams: {
				//获取用户列表参数
				pageNumber: 1,
				pageSize: 10,
				realName: '', //真实姓名
				region: '', //区域id
				unitId: '', //单位ID
				username: '' //用户名
			},
			userListDialogVisible: false,
			userList: [], //用户列表
			userTotal: 0,
			curSelectUser: {}, //当前选择用户
			curSelectEmcee: 'one', //当前选择的是第几个负责人one为第一负责人two为第二负责人
			researchFieOptions: [],
			timer: null //定时器
		};
	},
	async created() {
		await this.getPlatformInformationData();
		await this.getResearchFie();
		await this.getDiscipline();
		let data = this.$route.query.data;
		if (data) {
			this.pageTitle = '修改在研课题';
			let params = JSON.parse(decodeURIComponent(data));
			console.log('传递的数据', params);
			// 处理传递过来的数据
			// 处理预期成果
			if (params.expectedResearchResults) {
				params.expectedResearchResults = params.expectedResearchResults.split(',').map(item => {
					return item;
				});
			} else {
				params.expectedResearchResults = [];
			}
			// 根据课题级别获取课题类别
			this.topicTypeOptions = this.topicLevelOptions.find(item => {
				return item.id == params.projectLevelId;
			}).children;
			// 处理第二负责人
			if (params.twoEmceeId) {
				params.twoEmceeValue = `${params.twoEmceeName}(${params.twoUnitName})`;
			}
			// 处理研究领域数据
			// if (params.researchFieId) {
			// 	params.researchFieId = [params.researchFieId]
			// }
			console.log('处理后的数据', params);
			this.addTopicForm = params;
		}
	},
	methods: {
		// 递归找到研究领域名称
		getResearchFieName(id, data) {
			data.forEach(item => {
				if (item.id == id) {
					this.addTopicForm.researchFieName = item.name;
				} else {
					if (item.children) {
						this.getResearchFieName(id, item.children);
					}
				}
			});
		},
		// 创建课题
		createTopic() {
			if (this.timer) {
				clearTimeout(this.timer);
			}
			setTimeout(() => {
				this.$refs.addTopicFormRef.validate(valid => {
					if (valid) {
						// 处理研究领域-找到研究领域名称
						if (this.addTopicForm.researchFieId instanceof Array) {
							if (this.addTopicForm.researchFieId.length) {
								this.getResearchFieName(this.addTopicForm.researchFieId[this.addTopicForm.researchFieId.length - 1], this.researchFieOptions);
							}
						}
						// 处理立项编号
						this.addTopicForm.projectNumber = this.addTopicForm.projectNumberPrefix;

						let params = JSON.parse(JSON.stringify(this.addTopicForm));
						console.log(params);
						// 处理学科数据
						let disciplineObj = this.disciplineOptions.find(item => {
							return item.id == params.disciplineId;
						});
						params.disciplineName = disciplineObj.name;
						// 处理预期结果数据
						if (params.expectedResearchResults.length) {
							params.expectedResearchResults = params.expectedResearchResults.join(',');
						} else {
							params.expectedResearchResults = '';
						}
						//处理学段
						let learningTypeObj = this.learningTypeList.find(item => {
							return item.id == params.learningType;
						});
						params.learningTypeName = learningTypeObj.label;
						// 课题级别
						let projectLevelObj = this.topicLevelOptions.find(item => {
							return item.id == params.projectLevelId;
						});
						params.projectLevelName = projectLevelObj.name;
						//课题类别
						this.topicLevelOptions.forEach(item => {
							if (item.id == params.projectTypeId) {
								params.projectTypeName = item.name;
							} else {
								if (item.children && item.children.length > 0) {
									item.children.forEach(item1 => {
										if (item1.id == params.projectTypeId) {
											params.projectTypeName = item1.name;
										}
									});
								}
							}
						});
						if (params.researchFieId) {
							// 处理研究领域数据
							params.researchFieId = params.researchFieId[params.researchFieId.length - 1];
						}

						// 项目编号的3位随机数
						// params.projectNumber = params.projectNumberPrefix+''+(Math.floor(Math.random()*1000))
						console.log('处理后数据', params);
						this.createOrEditUnderStudyTopic(params);
					}
				});
			}, 1500);
		},
		// 创建或者修改在研课题
		async createOrEditUnderStudyTopic(data) {
			const res = await createOrEditUnderStudyTopic(data);
			if (res.code == 200) {
				if (this.pageTitle == '修改在研课题') {
					this.$message.success('修改在研课题成功！');
				} else {
					this.$message.success('创建在研课题成功！');
				}
				this.$router.push('/backstage/topicSummary');
			} else {
				this.$message.error(res.data);
			}
		},
		// 清空用户
		clearUser(type) {
			if (type == 'one') {
				this.addTopicForm.oneEmceeId = '';
				this.addTopicForm.oneEmceeName = '';
				this.addTopicForm.oneUnitName = '';
			} else if (type == 'two') {
				this.addTopicForm.twoEmceeId = '';
				this.addTopicForm.twoEmceeName = '';
				this.addTopicForm.twoEmceeValue = '';
			}
		},
		// 选择用户
		selectUser(type) {
			if (type == 'one') {
				this.curSelectEmcee = 'one';
			} else if (type == 'two') {
				this.curSelectEmcee = 'two';
			}
			this.userListDialogVisible = true;
			if (this.userList.length === 0) {
				this.userParams = {
					pageNumber: 1,
					pageSize: 10,
					realName: '', //真实姓名
					region: '', //区域id
					unitId: '', //单位ID
					username: '' //用户名
				};
				this.getUserList(this.userParams);
			}
		},
		// 表格单选
		async handleCurrentChange(val) {
			const res = await isHasNotFinishTopic(val.id);
			if (res.code == 200) {
				this.curSelectUser = val;
				this.$message.success('当前用户可以选择！');
			} else {
				this.curSelectUser = {};
				this.$message.error(res.data + '，请重新选择！');
			}
		},
		// 用户搜索
		search() {
			console.log(this.userParams);
			let params = JSON.parse(JSON.stringify(this.userParams));
			params.region = params.region[params.region.length - 1];
			params.pageNumber = 1;
			console.log('处理后数据', params);
			this.getUserList(params);
		},
		// 获取所有用户列表
		async getUserList(data) {
			const res = await getUserList(data);
			if (res.code == 200) {
				console.log('用户列表', res);
				this.userList = res.data.records;
				this.userTotal = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		// 获取课题级别类别目录
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(1);
			console.log('课题级别', res);
			if (res.code == 200) {
				this.topicLevelOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 课题级别选择
		topicLevelChange(val) {
			console.log(val);
			let topicTypeObj = this.topicLevelOptions.find(item => {
				return item.id == val;
			});
			console.log('课题级别', topicTypeObj);
			//获取所选课题级别名称
			this.topicTypeOptions = topicTypeObj.children;
		},
		// 课题级别选择
		topicLevelChange(val) {
			console.log(val);
			let topicTypeObj = this.topicLevelOptions.find(item => {
				return item.id == val;
			});
			console.log('课题级别', topicTypeObj);
			//获取所选课题级别名称
			this.topicTypeOptions = topicTypeObj.children;
			this.addTopicForm.projectTypeId = '';
			this.addTopicForm.projectTypeName = '';
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(8);
			if (res.code == 200) {
				console.log('学科', res);
				this.disciplineOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取研究领域
		async getResearchFie() {
			const res = await getPlatformInformationData(6);
			if (res.code == 200) {
				console.log('研究领域', res);
				this.researchFieOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		handleSizeChange(val) {
			this.userParams.pageSize = val;
			if (this.userParams.region) {
				this.userParams.region = this.userParams.region[this.userParams.region.length - 1];
			}
			this.getUserList(this.userParams);
		},
		currentPageNumberChange(val) {
			this.userParams.pageNumber = val;
			if (this.userParams.region) {
				this.userParams.region = this.userParams.region[this.userParams.region.length - 1];
			}
			this.getUserList(this.userParams);
		},
		// 确认用户
		confirmUser() {
			if (Object.keys(this.curSelectUser).length === 0) {
				this.$message.warning('请选择没有正在进行的课题的用户！');
				return;
			}
			if (this.curSelectEmcee == 'one') {
				this.addTopicForm.oneEmceeId = this.curSelectUser.id;
				this.addTopicForm.oneEmceeName = this.curSelectUser.realName;
				// this.addTopicForm.oneEmceeValue = `${this.curSelectUser.realName}(${this.curSelectUser.unitName})`;
				this.addTopicForm.oneUnitName = this.curSelectUser.unitName;
			} else if (this.curSelectEmcee == 'two') {
				this.addTopicForm.twoEmceeId = this.curSelectUser.id;
				this.addTopicForm.twoEmceeName = this.curSelectUser.realName;
				this.addTopicForm.twoEmceeValue = `${this.curSelectUser.realName}(${this.curSelectUser.unitName})`;
			}
			this.userListDialogVisible = false;
		}
	}
};
</script>

<style scoped lang="scss"></style>
